import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/components/utils";
import { node, string } from "prop-types";
import withValidation from "@/hocs/withValidation";

let Checkbox = React.forwardRef(
  ({ className, label, id, validation, ...props }, ref) => {
    return (
      <div
        onClick={(evt) => {
          evt.stopPropagation(); // Prevents undesired triggers when used inside a clickable parent
        }}
      >
        <div className="flex items-center gap-4">
          <CheckboxPrimitive.Root
            ref={ref}
            className={cn(
              "peer h-6 w-6 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
              className,
              validation.className,
            )}
            id={id}
            {...props}
          >
            <CheckboxPrimitive.Indicator
              className={cn("flex items-center justify-center text-current")}
            >
              <Check className="h-6 w-6" />
            </CheckboxPrimitive.Indicator>
          </CheckboxPrimitive.Root>
          {label && (
            <label htmlFor={id} className="m-0">
              {label}
            </label>
          )}
        </div>
        <div className="pl-10">{validation.elements}</div>
      </div>
    );
  },
);

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

Checkbox.propTypes = {
  label: node,
  className: string,
};

Checkbox = withValidation()(Checkbox);

export { Checkbox };
